import React from 'react';
import { InvalidParamsSection } from '~/components/domains/InvalidParamsSection';

export type Props = {};

export const InvalidParamsPage: React.FC<Props> = () => {
  return <InvalidParamsSection />;
};
